import type { IconSvgObject } from './types';

const LocationOffline04Icon: IconSvgObject = [
  ["path", { d: "M16.9124 16.9124C15.5849 18.2231 14.1142 19.4641 12.9213 20.8289C12.4533 21.3644 11.5669 21.3502 11.1092 20.806C8.21916 17.3692 3.5 14.9412 3.5 10.0807C3.5 8.25332 4.13806 6.5676 5.21393 5.21393M7.5 3.22404C8.80503 2.44833 10.3474 2 12 2C16.6944 2 20.5 5.61786 20.5 10.0807C20.5 11.8459 19.8643 13.3159 18.9143 14.6383", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LocationOffline04Icon;
